<app-banner [heading]="'ACADEMIC SCHEDULE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main"><!-- ======= Recent Activities Section ======= -->
    <section class="events" id="events">
    <div class="container" data-aos="fade-up">
    <div class="row">
    <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
            <div class="card-img"><img alt="best school in kurukshetra" src="assets/img/calendar/academic-schedule.jpg"></div>

            <div class="card-body">
                <h5 class="card-title"><a href="https://drive.google.com/file/d/1cFcbgzJLdTaBHLhLjg2H9ad2p1UgWemL/view?usp=sharing" target="_blank">WORKING, REVISION &amp; TEST DAY SCHEDULE</a> </h5>
                <a href="https://drive.google.com/file/d/1cFcbgzJLdTaBHLhLjg2H9ad2p1UgWemL/view?usp=sharing" target="_blank">View &amp; Download</a><br>
            </div>
        </div>
    </div>
    
    <div class="col-md-8 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><a href="https://drive.google.com/file/d/1cFcbgzJLdTaBHLhLjg2H9ad2p1UgWemL/view?usp=sharing" target="_blank"><img alt="..." src="assets/img/calendar/syllabus.jpg"> </a></div>
    </div>
    </div>
    </div>
    </div>
    </section>
    </main>